import { useState } from 'react';
import ClientCookies from 'js-cookie';
import { safeJsonParse } from 'src/utils/json';
import { IS_LOCAL } from 'src/interviews/requests/settings';

const GEOLOCATION = {
  cookieName: '_bh_gloc',
};

interface IGeolocation {
  admin1?: string;
  admin1_code?: string;
  city?: string;
  country?: string;
  country_code?: string;
  latitude?: number;
  longitude?: number;
  postal?: string;
}

const DEFAULT_LOCATION: IGeolocation = {
  country: 'United States',
  country_code: 'US',
};

export default function useGeolocation() {
  const [value] = useState(() => {
    if (typeof window !== 'undefined') {
      const geolocationFromCookie = ClientCookies.get(GEOLOCATION.cookieName) || '{}';
      const decodedGeolocation = safeJsonParse<IGeolocation>(
        decodeURIComponent(geolocationFromCookie),
      );

      return IS_LOCAL ? DEFAULT_LOCATION : decodedGeolocation;
    }

    return IS_LOCAL ? DEFAULT_LOCATION : undefined;
  });

  return value;
}
